export default Object.freeze({
  NONE: 0,
  BANK_TRANSACTION: 1,
  WEBPAY: 2,
  CARRIER: 3,
  GOPAY: 4,
});
